import { Type } from '@angular/core';
import {
    MonitoringGridComponent,
    WidgetComponent,
} from '@pages/monitoring/dashboard/widgets/generics';

export interface IWidget {
    type: WidgetType;
    resource: WidgetResource;
    source: WidgetSource;
    widget: Type<WidgetComponent<any> | MonitoringGridComponent<any>>;
    layout: IWidgetLayout;
}

export interface IWidgetLayout {
    width: number;
    height?: number;
}

export enum WidgetSource {
    RobotState = 'RobotState',
    RobotHealth = 'RobotHealth',
    RobotRuntimes = 'RobotRuntimes',
    Error = 'Error',
    Live = 'Live',
    JobRuns = 'JobRuns',
    ProcessedQueueItems = 'ProcessedQueueItems',
    UnprocessedQueueItems = 'UnprocessedQueueItems',
    QueueDynamics = 'QueueDynamics',
    QueueRetryRate = 'QueueRetryRate',
    ProcessedItemsEvolution = 'ProcessedItemsEvolution',
    ItemsInProgress = 'ItemsInProgress',
    Timing = 'Timing',
    QueueHealth = 'QueueHealth',
    QueueSlaHealth = 'QueueSlaHealth',
    JobsHealth = 'JobsHealth',
    JobsCount = 'JobsCount',
    ScheduledJobs = 'ScheduledJobs',
    RunningJobs = 'RunningJobs',
    FinishedJobs = 'FinishedJobs',
    Items = 'Items',
}

export enum WidgetType {
    Doughnut = 'Doughnut',
    HealthState = 'HealthState',
    Feed = 'Feed',
    Line = 'Line',
    WideTable = 'WideTable',
    NarrowTable = 'NarrowTable',
    Count = 'Count',
    Bar = 'Bar',
}

export enum WidgetResource {
    QueueSla = 'queues-sla',
    Queue = 'queues',
    Robot = 'robots',
    Job = 'jobs',
}
